import { formatMoney } from '@lib/utils';

export default (props) => {
  const { properties: similarProperties, address } = props;
  const similarPropertiesData = similarProperties.map((property) => {
    return {
      image: {
        height: '197px',
        src: property.mainPhoto.midSizeImageUrl,
        width: '290px'
      },
      property: {
        address: property.address,
        alertPills: property.alertPills,
        alerts: property.alerts,
        city: property.city,
        details: [
          { br: property.bedroomCount },
          { ba: `${property.fullBathroomCount}/${property.partBathroomCount}` },
          { ac: property.acres }
        ],
        listingId: property.listingId,
        price: formatMoney(property.price),
        realtor: {
          isActiveSibcyAgent: !property.isIdxListing,
          primaryRealtorName: property.primaryAgentDisplayOne,
          secondaryRealtorName: property.secondaryAgentDisplayOne
        },
        state: property.state,
        zip: property.zip
      },
      url: `/listing/${property.listingId}`
    };
  });
  return {
    ...props,
    address: typeof address === 'string' && address.trim().length > 0 ? address : undefined,
    properties: similarPropertiesData
  };
};
